import FontCollection from "#booster/classes/FontCollection";
import { useBoosterCritical, useBoosterConfig, useNuxtApp } from "#imports";
import { reactive, nextTick, onBeforeUnmount } from "vue";
export default function useBoosterFonts(options = {}) {
  const { isCritical } = useBoosterCritical(options);
  const runtimeConfig = useBoosterConfig();
  const nuxtApp = useNuxtApp();
  const fontCollection = reactive(new FontCollection());
  try {
    const entry = nuxtApp.$booster.head.push({
      fontCollection,
      isCritical: isCritical.value,
      options: runtimeConfig
    });
    onBeforeUnmount(() => nextTick(() => entry.dispose()));
  } catch (error) {
    console.error(error);
  }
  function $getFont(family, weight, style, options2) {
    if (typeof family === "object") {
      options2 = family.options;
      style = family.style;
      weight = family.weight;
      family = family.family;
    }
    return {
      runtimeConfig,
      isCritical: isCritical.value,
      fontCollection,
      definition: nuxtApp.$booster.getFont(family, weight, style, options2)
    };
  }
  return {
    isCritical,
    $getFont
  };
}
